/**
 * Předdefinovaný nástroj zobrazovače mapy.
 */
export enum ViewerTool {
    /**
     * Nástroj typu {@link ViewerToolType.GEOLOCATION}.
     */
    GEOLOCATION = 'GEOLOCATION',

    /**
     * Nástroj typu {@link ViewerToolType.NEW_OBJECT}.
     */
    NEW_OBJECT = 'NEW_OBJECT',

    /**
     * Nástroj typu {@link ViewerToolType.SELECT_FEATURES}.
     */
    SELECT_FEATURES = 'SELECT_FEATURES',

    /**
     * Nástroj typu {@link ViewerToolType.MEASURE_LINE}.
     */
    MEASURE_LINE = 'MEASURE_LINE',

    /**
     * Nástroj typu {@link ViewerToolType.MEASURE_POLYGON}.
     */
    MEASURE_POLYGON = 'MEASURE_POLYGON',
}
